export let config: any = {
    headers: {
        'Access-Token': 'frc48Lr8kIvFyd0myqvOgReAeH9Be1d1y0s',
    }
};

export let config2: any = {
    headers: {
        'StaticToken': '@8c191d9b-b139-4e45-8b85-8c0ca07cdd05!',
    }
};